// src/runtime/shared/browserFsStub.ts
// ============================================
// 浏览器环境 fs 模块桩（stub）
//
// 用途：
//   VaultBridge.ts 顶部 `import * as fs from 'fs'` 在浏览器环境会加载失败，
//   因为 Vite 不会为 Node 内置 fs 模块提供 polyfill。
//   此桩通过 vite.config.ts 的 resolve.alias 注入，
//   让浏览器端的 fs import 返回安全空值，真正读写由 BrowserVaultReader 经 /vault-api 完成。
//
// 设计原则：
//   1. 所有方法返回安全空值（false / [] / '' / undefined），不抛异常
//   2. 写方法静默成功（返回 undefined），实际写入由 BrowserVaultReader 处理
//   3. VaultBridge.checkAvailability() 会先检测浏览器环境并切换到 browserMode，
//      不会真正调用这些桩方法
// ============================================

export const existsSync = (_path: string): boolean => false;
export const readdirSync = (_path: string, _options?: any): string[] | any[] => [];
export const readFileSync = (_path: string, _options?: any): string => '';
export const writeFileSync = (_path: string, _data: any, _options?: any): void => {};
export const mkdirSync = (_path: string, _options?: any): void => {};
export const statSync = (_path: string): any => ({
  isFile: () => false,
  isDirectory: () => false,
  size: 0,
  mtime: new Date(),
  ctime: new Date(),
});
export const unlinkSync = (_path: string): void => {};
export const renameSync = (_oldPath: string, _newPath: string): void => {};
export const copyFileSync = (_src: string, _dest: string): void => {};
export const appendFileSync = (_path: string, _data: any, _options?: any): void => {};
export const accessSync = (_path: string, _mode?: number): void => {};
export const lstatSync = (_path: string): any => ({
  isFile: () => false,
  isDirectory: () => false,
  isSymbolicLink: () => false,
  size: 0,
  mtime: new Date(),
});
export const realpathSync = (_path: string): string => _path;
export const createReadStream = (_path: string): any => ({ pipe: () => {}, on: () => {} });
export const createWriteStream = (_path: string): any => ({ write: () => {}, end: () => {}, on: () => {} });

// 常量（与 fs.constants 兼容）
export const constants = {
  F_OK: 0,
  R_OK: 4,
  W_OK: 2,
  X_OK: 1,
};

export default {
  existsSync,
  readdirSync,
  readFileSync,
  writeFileSync,
  mkdirSync,
  statSync,
  unlinkSync,
  renameSync,
  copyFileSync,
  appendFileSync,
  accessSync,
  lstatSync,
  realpathSync,
  createReadStream,
  createWriteStream,
  constants,
  promises: {
    readFile: async () => '',
    writeFile: async () => undefined,
    readdir: async () => [],
    mkdir: async () => undefined,
    stat: async () => ({ isFile: () => false, isDirectory: () => false, size: 0, mtime: new Date() }),
    unlink: async () => undefined,
    rename: async () => undefined,
    access: async () => undefined,
    exists: async () => false,
  },
};
